export default "__VITE_ASSET__BcEjXwgi__"